/* Eya Clean Pro — Product Detail Page & Variants */

class ProductManager {
  constructor() {
    this.initGallery();
    this.initVariants();
    this.initStickyBuyBar();
  }

  initGallery() {
    const thumbs = document.querySelectorAll(".product-thumb");
    const mainImg = document.querySelector(".product-gallery-main img");
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener("click", () => {
        thumbs.forEach(t => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
        const newSrc = thumb.dataset.mediaSrc;
        if (newSrc) {
          mainImg.style.opacity = "0";
          setTimeout(() => {
            mainImg.src = newSrc;
            mainImg.style.opacity = "1";
          }, 150);
        }
      });
    });
  }

  initVariants() {
    const variantChips = document.querySelectorAll(".variant-chip");
    const hiddenSelect = document.querySelector("[data-product-select]");
    if (!variantChips.length || !hiddenSelect) return;

    variantChips.forEach(chip => {
      chip.addEventListener("click", () => {
        const group = chip.closest(".variant-chips");
        group.querySelectorAll(".variant-chip").forEach(c => c.classList.remove("is-selected"));
        chip.classList.add("is-selected");

        const variantId = chip.dataset.variantId;
        if (variantId) {
          hiddenSelect.value = variantId;
          hiddenSelect.dispatchEvent(new Event("change"));
        }
      });
    });
  }

  initStickyBuyBar() {
    const buyArea = document.querySelector(".product-buy-buttons");
    const stickyBar = document.querySelector(".sticky-buy-bar");
    if (!buyArea || !stickyBar) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          stickyBar.classList.add("is-visible");
        } else {
          stickyBar.classList.remove("is-visible");
        }
      });
    }, { threshold: 0 });

    observer.observe(buyArea);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new ProductManager();
});
